import AbstractTab from "./AbstractTab";

export default class ElementsTab extends AbstractTab {
    name = 'elements';
    tooltip = 'Elements (T)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#shape-line"></use></svg>';

    rows = [];

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv()
            .parent(tabContainer)
            .class('planner-aside-wrapper');

        let header = this.p.createElement('H3', 'Elements in this plan')
            .parent(this.container)
            .class('mar-t-0 mar-b-0');

        this.rowContainer = this.p.createDiv().parent(this.container);

        this.container.hide();

        // this.resizeWindow();
    }

    push(row) {
        this.rows.push(row);
    }

    positionElementsOverview() {
        // this.container.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        // this.positionElementsOverview();
    }

    activate() {
        // this.button.addClass('-is-active');
        this.container.show();
    }

    deactivate() {
        // this.button.removeClass('-is-active');
        this.container.hide();
    }
}
